import { useCallback } from "react";

import { useCallEReputationMutation } from "src/core/gql/graphql";

type CallSafelyParams = {
  folderFileId: string;
  /**
   * Contexte pour faciliter le debug dans les logs
   * (ex: "useUpdatePPH::onSubmit")
   */
  logContext: string;
};

/**
 * Ce hook centralise l’appel eReputation avec gestion d’erreur.
 * Il évite de dupliquer le try/catch + context suppressRedirect dans chaque onSubmit.
 */
export const useEReputation = () => {
  const [callEReputation] = useCallEReputationMutation();

  const callSafely = useCallback(
    async ({ folderFileId, logContext }: CallSafelyParams) => {
      try {
        await callEReputation({
          variables: { folderFileId },
          context: { suppressRedirect: true },
        });
      } catch (error) {
        console.error(`[${logContext}] callEReputation failed`, error);
      }
    },
    [callEReputation]
  );

  return { callSafely };
};
